import React from 'react';
import Navbar from "../components/Navbar";

export default class Resume extends React.Component {
    render() {
        return (
            <div className="dark-background d-flex justify-content-center" style={{minHeight: '90vh', paddingBottom: '40px'}}>
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center page-title-wrapper">
                        <div className="col-sm-3 col-xs-12" style={{textAlign: 'center', minWidth: '200px', paddingLeft: '25px'}}>
                            <h1 className="font-satisfy font-peach page-title">Resume</h1>
                            <hr className="flaired-edge-separator disappear-xs-screen"/>
                        </div>
                    </div>

                    <div className="row d-flex justify-content-center align-items-center" style={{ marginTop: 20 }}>
                        <form method="get" action="files/Deanna_Dunmyer_2022_acting_resume.pdf">
                            <button type="submit" id="download-pdf-button" className="btn font-josefin">Download</button>
                        </form>
                    </div>

                    <div className="row d-flex justify-content-center align-items-center" style={{ marginTop: 40 }}>
                        <div style={{width: 400, height: 600, backgroundImage: 'url(\'images/Crimes_of_the_Heart.jpg\')', backgroundSize: "contain", backgroundRepeat: "no-repeat"}}/>

                    </div>
                </div>

                <Navbar links={[
                    { text: 'Home', reference: '/home' },
                    { text: 'Resume', reference: '/resume', extraClasses: 'active-link' },
                    { text: 'Gallery', reference: '/gallery' },
                    { text: 'Voice', reference: '/voice' },
                    { text: 'Press', reference: '/press' },
                    { text: 'Contact', reference: '/contact' }
                ]}/>
            </div>
        );
    }
}